// extracted by css-extract-rspack-plugin
export default {"wrapper":"jhvQu","icon":"ouyVg","title":"oz0Er","button_override":"D4hmM","buttonOverride":"D4hmM","#":"yC5xt"};